import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { selectHubspotContact, getHubspotLink, copyToClipboard, getSlackDeepLink, resendKeyInsightsSlack, resendKeyInsightsEmail, generateSummary, getTranscriptionAsText, getUserAccessToken, addBulletListTags, addNewlineTags, addColourToNames, trackEvent, highlightText, checkIfStandardSummaryIsEligible, openCheckoutSessionInNewTab } from '../../utils/genericUtils'
import { SummaryNotFound } from '../edgeCaseStates/SummaryNotFound'
import { IconWithTimeoutReplaceOnClick } from '../../utils/IconWithTimeoutReplaceOnClick'
import { ButtonWithTimeoutReplaceOnClick } from '../../utils/ButtonWithTimeoutReplaceOnClick'
import { Dropdown } from '../controls/Dropdown'
import { HoverDropdownMenu } from '../controls/HoverDropdownMenu'
import { SearchableDropdown } from '../controls/SearchableDropdown'
import SlackIcon from '../../images/slack_icon.png'
import HubspotIcon from '../../images/hubspot_icon.png'

const PRO_BADGE = <div style={{ marginLeft: 3, display: 'inline-block', background: '#F97238', padding: '2px 5px', borderRadius: 4, fontSize: 12, fontWeight: 700 }}>PRO</div>

const SummarySection = ({ custom_bullet_summary_label, header, text, setShowZoomTranscriptInfoPopup, setShowMsTeamsTranscriptInfoPopup, isBackend, getSpeakerColourByName, searchWords }) => {
  const isError = text?.error

  var formattedText;

  if (header === '🤖 Call summary') {
    formattedText = text
  }
  if (header === '📍 Bullet summary') {
    if (custom_bullet_summary_label?.trim()?.length) {
      header = custom_bullet_summary_label
    }
    formattedText = addBulletListTags(text)
  }
  if (header === '💡 Key insights') {
    formattedText = addNewlineTags(addBulletListTags(text), "^Discussion Topic:")
  }
  if (header === '🎯 Action items') {
    formattedText = addColourToNames(addBulletListTags(text), getSpeakerColourByName)
  }

  return <>
    <div className="summary-section">
      <div>
        <h4>{header}</h4>
        {text && !isError ? <div style={{ width: 14, height: 14 }}>
          <IconWithTimeoutReplaceOnClick onClick={() => copyToClipboard(text)}
            initialIcon={<svg width="14" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.719 12.7191V3.81277H4.7488V12.7191H11.719ZM11.719 2.5617C12.0566 2.5617 12.3545 2.69078 12.6126 2.94894C12.8708 3.18723 12.9999 3.47518 12.9999 3.81277V12.7191C12.9999 13.0567 12.8708 13.3546 12.6126 13.6128C12.3545 13.8709 12.0566 14 11.719 14H4.7488C4.41121 14 4.11334 13.8709 3.85518 13.6128C3.59703 13.3546 3.46795 13.0567 3.46795 12.7191V3.81277C3.46795 3.47518 3.59703 3.18723 3.85518 2.94894C4.11334 2.69078 4.41121 2.5617 4.7488 2.5617H11.719ZM9.81263 0V1.28085H2.1871V10.1872H0.936035V1.28085C0.936035 0.943262 1.05518 0.64539 1.29348 0.387234C1.55164 0.129078 1.84951 0 2.1871 0H9.81263Z" fill="#E44867" />
            </svg>}
            clickedIcon={<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#E44867" d="M6.38498 12.0188L13.5962 4.80751L12.4695 3.64319L6.38498 9.7277L3.53052 6.87324L2.40376 8L6.38498 12.0188ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z" />
            </svg>
            } />
        </div> : <span></span>}

      </div>
      {header === 'Action items' && isBackend ? <div className="black">
        Action items not looking good? Make sure you upload the transcript with participants names: <a onClick={() => {

          trackEvent("briefly-how-to-get-zoom-transcripts-click", {
            source: 'SUMMARY_TAB'
          })

          setShowZoomTranscriptInfoPopup(true)

        }}>How to get transcripts for Zoom</a>, <a onClick={() => {

          trackEvent("briefly-how-to-get-ms-teams-transcripts-click", {
            source: 'SUMMARY_TAB'
          })

          setShowMsTeamsTranscriptInfoPopup(true)
        }

        }>How to get transcripts for MS Teams</a>
      </div> : ''}
      <p>
        {isError ? 'OpenAI error. Please try again later...' : searchWords ? highlightText(text, searchWords, { background: '#F9C338', color: 'black' }) : text ? <div dangerouslySetInnerHTML={{ __html: formattedText }}></div> : 'Please ensure that you have uploaded the transcript in the correct format as action items are displayed for each meeting participant.'}
      </p>
    </div>
  </>
}

const SUMMARY_COLUMNS_CONFIG = [
  [
    {
      label: '🤖 Call summary',
      key: 'short_summary'
    },
    {
      label: '💡 Key insights',
      key: 'key_insights'
    }
  ],
  [
    {
      label: '📍 Bullet summary',
      key: 'long_summary'
    }
  ],
  [
    {
      label: '🎯 Action items',
      key: 'action_items'
    }
  ]
]

const LANGUAGE_AUTO_DETECT = 'Auto detect'

const AVAILABLE_LANGUAGES = [
  LANGUAGE_AUTO_DETECT,
  "Afrikaans (South Africa)",
  "Albanian (Albania)",
  "Amharic (Ethiopia)",
  "Arabic (Arab Emirates)",
  "Arabic (Egypt)",
  "Arabic (Levant)",
  "Arabic (Maghrebi)",
  "Armenian (Armenia)",
  "Basque (Spain)",
  "Bengali (Bangladesh)",
  "Bulgarian (Bulgaria)",
  "Burmese (Myanmar)",
  "Catalan (Spain)",
  "Chinese, Mandarin (Simplified)",
  "Chinese, Mandarin (Traditional)",
  "Dutch",
  "English",
  "English (Australia)",
  "English (India)",
  "English (Philippines)",
  "English (UK)",
  "Estonian (Estonia)",
  "Filipino (Philippines)",
  "Finnish (Finland)",
  "French",
  "French (Canada)",
  "Galician (Spain)",
  "Georgian (Georgia)",
  "German",
  "Gujarati (India)",
  "Hebrew (Israel)",
  "Hindi",
  "Hungarian (Hungary)",
  "Indonesian (Indonesia)",
  "Italian",
  "Japanese",
  "Javanese (Indonesia)",
  "Kannada (India)",
  "Khmer (Cambodia)",
  "Kinyarwanda (Rwanda)",
  "Korean",
  "Latvian (Latvia)",
  "Macedonian (North Macedonia)",
  "Malayalam (India)",
  "Marathi (India)",
  "Mongolian (Mongolia)",
  "Nepali (Nepal)",
  "Northern Sotho (South Africa)",
  "Norwegian (Norway)",
  "Persian (Iran)",
  "Polish (Poland)",
  "Portuguese (Brazil)",
  "Portuguese (Portugal)",
  "Romanian (Romania)",
  "Russian",
  "Sesotho (South Africa)",
  "Sinhala (Sri Lanka)",
  "Slovak (Slovakia)",
  "Slovenian (Slovenia)",
  "Spanish (Mexico)",
  "Spanish (Spain)",
  "Sundanese (Indonesia)",
  "Swahili",
  "Swati (South Africa)",
  "Swedish (Sweden)",
  "Tamil (India)",
  "Telugu (India)",
  "Thai (Thailand)",
  "Tshivenda (South Africa)",
  "Tswana (South Africa)",
  "Turkish (Turkey)",
  "Urdu (Pakistan)",
  "Uzbek (Uzbekistan)",
  "Vietnamese (Vietnam)",
  "Xhosa (South Africa)",
  "Xitsonga (South Africa)",
  "Zulu (South Africa)"
]

function greenSuccessCheckBoxOrGrayCross(isSuccess, successText, notSuccessText) {

  var icon;
  var text;

  if (isSuccess) {
    text = successText
    icon = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: 12 }}>
      <path d="M4.78873 9.01408L9.77459 4.02823C10.0091 3.79372 10.0122 3.41449 9.78157 3.17617C9.54554 2.93227 9.15544 2.92907 8.91544 3.16907L4.78873 7.29578L3.07141 5.57846C2.83751 5.34455 2.45827 5.34455 2.22436 5.57846C1.99123 5.81159 1.99034 6.18929 2.22238 6.42352L4.78873 9.01408ZM1.74648 1.77465C2.92958 0.591549 4.34742 0 6 0C7.65258 0 9.06103 0.591549 10.2254 1.77465C11.4085 2.93897 12 4.34742 12 6C12 7.65258 11.4085 9.07042 10.2254 10.2535C9.06103 11.4178 7.65258 12 6 12C4.34742 12 2.92958 11.4178 1.74648 10.2535C0.58216 9.07042 0 7.65258 0 6C0 4.34742 0.58216 2.93897 1.74648 1.77465Z" fill="#80BF28" />
    </svg>
  } else {
    text = notSuccessText
    icon = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: 12 }}>
      <g clipPath="url(#clip0_443_4376)">
        <path d="M7.2947 8.13121C7.52572 8.36222 7.90027 8.36222 8.13128 8.13121C8.36229 7.90019 8.36229 7.52565 8.13128 7.29463L6.83658 5.99993L8.13128 4.70523C8.36229 4.47421 8.36229 4.09966 8.13128 3.86865C7.90026 3.63764 7.52572 3.63764 7.2947 3.86865L6 5.16335L4.7053 3.86865C4.47428 3.63764 4.09974 3.63764 3.86872 3.86865C3.63771 4.09966 3.63771 4.47421 3.86872 4.70523L5.16342 5.99993L3.86872 7.29463C3.63771 7.52565 3.63771 7.90019 3.86872 8.13121C4.09973 8.36222 4.47428 8.36222 4.7053 8.13121L6 6.83651L7.2947 8.13121ZM5.98008 0.00446091C7.65324 0.00446095 9.07409 0.588737 10.2426 1.75729C11.4112 2.92584 11.9888 4.34005 11.9755 5.99993C11.9888 7.6598 11.4112 9.07402 10.2426 10.2426C9.07409 11.4111 7.65324 11.9954 5.98008 11.9954C4.33349 11.9954 2.92591 11.4111 1.75736 10.2426C0.588808 9.07402 -0.00210798 7.6598 -0.0153871 5.99993C-0.00210794 4.34005 0.588808 2.92584 1.75736 1.75729C2.92591 0.588737 4.33349 0.00446087 5.98008 0.00446091Z" fill="#6D6D6D" />
      </g>
      <defs>
        <clipPath id="clip0_443_4376">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>

  }

  return <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
    {icon}
    <span style={{ marginLeft: 10, "color": isSuccess ? "var(--text-text-secondary, #C6C6C6)" : '#6D6D6D', "fontFeatureSettings": "'clig' off, 'liga' off", "fontFamily": "Roboto", "fontSize": "14px", "fontStyle": "normal", "fontWeight": "400", "lineHeight": "20px", "letterSpacing": "0.15px" }}>{text}</span>
  </div>

}

export default function MeetingTabSummary({ isBackend, userData, aiSummaryCostsAiCredit, meetingSummaryWasRequestedBefore, meetingData, backendMeetingData, setShowZoomTranscriptInfoPopup, setShowMsTeamsTranscriptInfoPopup, setShowOutOfCreditsPopup, searchWords, loadBackendMeetingData }) {

  const navigate = useNavigate()

  const userIsPaid = (userData.subscription_is_active || (!!userData.admin_user && userData.admin_user_subscription_is_active))

  const slackIsConnected = !!userData.slack_workspace_name

  const { meetingId } = meetingData

  const {
    email_summary_sent_to_myself, email_summary_sent_to_everyone,
    slack_summary_sent_to_team_id, slack_summary_sent_to_channel_id,
    meeting_participants_emails,
    hubspot_meeting_id, hubspot_portal_id,
    hubspot_contact_ids_where_summary_is_saved,
    could_not_detect_hubspot_contact
  } = backendMeetingData

  const isSavedToHubspot = !!hubspot_meeting_id

  const { is_hubspot_connected } = userData

  const [meetingSummary, setMeetingSummary] = useState(null)

  const [selectedLanguage, setSelectedLanguage] = useState(LANGUAGE_AUTO_DETECT)
  const [selectedUnconfirmedLanguage, setSelectedUnconfirmedLanguage] = useState(null)
  const [newLanguageSummaryIsLoading, setNewLanguageSummaryIsLoading] = useState(false)

  const [langDropdownIsOpen, setLangDropdownIsOpen] = useState(false)

  const [isGenerating, setIsGenerating] = useState(false)

  const LOCASTORAGE_SUMMARY_KEY = 'summary-cache-' + meetingId

  const MAX_STORED_SUMMARIES = 1000

  const { custom_bullet_summary_label } = userData

  // Clearing latest local storage entries if is it going to be overloaded soon
  const isStorageOverloaded = () => {
    var count = 0
    for (const key in localStorage) {
      if (key.includes('summary-cache-')) {
        count++
      }
    }
    return count >= MAX_STORED_SUMMARIES
  }

  const removeOldestSummary = () => {
    var oldestTimestamp = null
    var oldestEntryKey = null
    for (const key in localStorage) {
      if (key.includes('summary-cache-')) {
        var { timestamp } = JSON.parse(localStorage.getItem(key))
        if (!timestamp) {
          oldestEntryKey = key;
          break;
        }
        if (!oldestTimestamp || timestamp.localeCompare(oldestTimestamp) < 0) {
          oldestTimestamp = timestamp;
          oldestEntryKey = key
        }
      }
    }
    localStorage.removeItem(oldestEntryKey)
  }

  const setMeetingSummaryInCache = (summaryData) => {
    localStorage.setItem(LOCASTORAGE_SUMMARY_KEY, JSON.stringify({
      ...summaryData,
      timestamp: new Date()
    }))
  }

  // const getMeetingSummary = async () => {
  //   setMeetingSummary(null)

  //   if(localStorage.getItem(LOCASTORAGE_SUMMARY_KEY)) {
  //     const summaryData = JSON.parse( localStorage.getItem(LOCASTORAGE_SUMMARY_KEY) )
  //     setMeetingSummary( summaryData )

  //     if(summaryData.selectedLanguage) {
  //       setSelectedLanguage(summaryData.selectedLanguage)
  //     }

  //     return
  //   }

  //   const meetingSummaryData = await new Promise(resolve => {

  //     const handler = e => {
  //       if(e.detail.getCachedSummaryById) {
  //         window.removeEventListener("background-message-response", handler)
  //         resolve({
  //           meetingSummary: e.detail.getCachedSummaryById
  //         })
  //       }
  //     }

  //     window.addEventListener("background-message-response", handler)

  //     window.dispatchEvent(new CustomEvent('background-message', { detail: { getCachedSummaryById: meetingId}}));
  //   })


  //   setMeetingSummary(meetingSummaryData.meetingSummary)
  // }

  // useEffect(() => {
  //   getMeetingSummary()
  // }, [])

  // useEffect(() => {

  //   getMeetingSummary()

  //   // setSelectedLanguage(meetingData.selectedLanguage ?? LANGUAGE_AUTO_DETECT)

  // }, [LOCASTORAGE_SUMMARY_KEY, backendMeetingData])

  useEffect(() => {
    if (backendMeetingData.long_summary) {
      setMeetingSummaryInCache({
        short_summary: backendMeetingData.short_summary,
        long_summary: backendMeetingData.long_summary,
        key_insights: backendMeetingData.key_insights,
        action_items: backendMeetingData.action_items
      })

      setMeetingSummary({
        ...backendMeetingData
      })
    } else {
      setMeetingSummary(null)
    }
  }, [backendMeetingData])

  function handleGenerateSummary(language = null) {

    checkIfStandardSummaryIsEligible(getTranscriptionAsText(meetingData), isEligible => {
      if (isEligible) {
        setIsGenerating(true)

        getUserAccessToken(({ access }) => {


          trackEvent("briefly-create-generate-ai-summary", {
            meetingSource: meetingData.isBackend ? 'UPLOAD' : 'BRIEFLY_EXTENSION'
          })

          generateSummary(
            getTranscriptionAsText(meetingData), meetingData.transcriptId, language, access, summaryData => {
              setIsGenerating(false)
              setNewLanguageSummaryIsLoading(false)

              summaryData.selectedLanguage = language

              setMeetingSummary(summaryData)

              if (isStorageOverloaded()) {
                removeOldestSummary()
              }

              setMeetingSummaryInCache(summaryData)
            }
          )


        })
      } else {
        setShowOutOfCreditsPopup(true)
      }
    })



  }

  const onLanguageChange = lang => () => {
    if (lang !== selectedLanguage) {
      setSelectedUnconfirmedLanguage(lang);
    }
  }

  const LANGUAGE_DROPDOWN_ITEMS = AVAILABLE_LANGUAGES.map(lang => ({
    label: lang,
    onSelect: userIsPaid ? onLanguageChange(lang) : () => {}
  }))

  const leftSidebar = <div style={{
    overflowY: 'auto',
    maxHeight: '100%',
    width: 302,
    minWidth: 302
  }}>
    <div style={{ width: 252, minWidth: 252, padding: 24, background: '#212121', borderRadius: 4, marginLeft: 10, marginTop: 12, marginBottom: 10 }} className="summary-left-sidebar">
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.493 9.61502H14.1972C14.3474 8.91393 14.4225 8.37559 14.4225 8C14.4225 7.62441 14.3474 7.08607 14.1972 6.38498H11.493C11.5681 6.9108 11.6056 7.44914 11.6056 8C11.6056 8.55086 11.5681 9.0892 11.493 9.61502ZM10.0657 14.0469C10.6917 13.8466 11.3427 13.471 12.0188 12.9202C12.6948 12.3443 13.2081 11.7684 13.5587 11.1925H11.1925C10.9421 12.1941 10.5665 13.1455 10.0657 14.0469ZM9.87793 9.61502C9.95305 9.0892 9.99061 8.55086 9.99061 8C9.99061 7.44914 9.95305 6.9108 9.87793 6.38498H6.12207C6.04695 6.9108 6.00939 7.44914 6.00939 8C6.00939 8.55086 6.04695 9.0892 6.12207 9.61502H9.87793ZM8 14.385C8.7011 13.3584 9.2144 12.2942 9.53991 11.1925H6.46009C6.7856 12.2942 7.2989 13.3584 8 14.385ZM4.80751 4.80751C5.10798 3.73083 5.48357 2.77934 5.93427 1.95305C5.30829 2.15336 4.64476 2.54147 3.94366 3.11737C3.26761 3.66823 2.76682 4.23161 2.44131 4.80751H4.80751ZM2.44131 11.1925C2.76682 11.7684 3.26761 12.3443 3.94366 12.9202C4.64476 13.471 5.30829 13.8466 5.93427 14.0469C5.43349 13.1455 5.0579 12.1941 4.80751 11.1925H2.44131ZM1.80282 9.61502H4.50704C4.43192 9.0892 4.39437 8.55086 4.39437 8C4.39437 7.44914 4.43192 6.9108 4.50704 6.38498H1.80282C1.65258 7.08607 1.57746 7.62441 1.57746 8C1.57746 8.37559 1.65258 8.91393 1.80282 9.61502ZM8 1.61502C7.2989 2.64163 6.7856 3.70579 6.46009 4.80751H9.53991C9.2144 3.70579 8.7011 2.64163 8 1.61502ZM13.5587 4.80751C13.2081 4.23161 12.6948 3.66823 12.0188 3.11737C11.3427 2.54147 10.6917 2.15336 10.0657 1.95305C10.5164 2.77934 10.892 3.73083 11.1925 4.80751H13.5587ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z" fill="white" />
          </svg>
          <h5 style={{ marginTop: 0, marginLeft: 10, marginBottom: 0 }}>Language
            {userIsPaid ? '' : PRO_BADGE}
          </h5>

        </div>
        <div>
          <p style={{ marginTop: 15, "color": "var(--text-text-secondary, #C6C6C6)", "fontFeatureSettings": "'clig' off, 'liga' off", "fontFamily": "Roboto", "fontSize": "14px", "fontStyle": "normal", "fontWeight": "400", "lineHeight": "20px", "letterSpacing": "0.15px" }}>Change the AI summary for this call.</p>
          <div style={{ display: 'flex' }}>
            <Dropdown
              disabled={isGenerating || !userIsPaid}
              isOpen={langDropdownIsOpen}
              setIsOpen={setLangDropdownIsOpen}
              items={LANGUAGE_DROPDOWN_ITEMS}
              selectedItem={LANGUAGE_DROPDOWN_ITEMS.find(x => x.label === (selectedUnconfirmedLanguage ?? selectedLanguage))}
              style={selectedUnconfirmedLanguage ? { maxWidth: 170 } : { flex: 1 }}
              isLoading={newLanguageSummaryIsLoading}
            />
            {selectedUnconfirmedLanguage ? <button onClick={() => {
              setNewLanguageSummaryIsLoading(true)
              setSelectedUnconfirmedLanguage(null)
              setSelectedLanguage(selectedUnconfirmedLanguage)
              handleGenerateSummary(selectedUnconfirmedLanguage)
            }} style={{
              margin: 0,
              marginLeft: 10,
              height: 40
            }}>
              Change
            </button> : ''}
          </div>
        </div>
      </div>

      {isBackend ? <>
        <hr style={{ background: '#434343', marginTop: 24, marginBottom: 24 }} />

        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="email">
                  <path id="icon" d="M18.0282 6.27193V4.38596L10 9.07895L1.97183 4.38596V6.27193L10 10.9211L18.0282 6.27193ZM18.0282 2.5C18.5603 2.5 19.0141 2.69006 19.3897 3.07018C19.7966 3.45029 20 3.88889 20 4.38596V15.614C20 16.1111 19.7966 16.5497 19.3897 16.9298C19.0141 17.3099 18.5603 17.5 18.0282 17.5H1.97183C1.43975 17.5 0.970266 17.3099 0.56338 16.9298C0.187793 16.5497 0 16.1111 0 15.614V4.38596C0 3.88889 0.187793 3.45029 0.56338 3.07018C0.970266 2.69006 1.43975 2.5 1.97183 2.5H18.0282Z" fill="white" />
                </g>
              </svg>
              <h5 style={{ marginTop: 0, marginLeft: 10, marginBottom: 0 }}>Email</h5>
            </div>
            <HoverDropdownMenu
              menuItems={[
                {
                  label: 'Re-send to myself',
                  labelOnClick: 'Sent to myself',
                  onClick: () => {
                    resendKeyInsightsEmail({ ...meetingData, ...backendMeetingData }, { sendToEveryone: false })
                    setTimeout(() => {
                      loadBackendMeetingData(false)
                    }, 4000)
                  },
                  icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_600_4421)">
                      <path d="M13.654 2.33918L15.147 0.850541C15.4622 0.536269 16 0.759512 16 1.20461V5.83831C16 6.45583 15.4458 6.92577 14.8366 6.82487L10.9241 6.17691C10.5222 6.11034 10.3643 5.61679 10.653 5.32932L12.1994 3.78947C11.0108 2.60429 9.60313 2.0117 7.97654 2.0117C6.31867 2.0117 4.89541 2.60429 3.70674 3.78947C2.54936 4.94347 1.97067 6.34698 1.97067 8C1.97067 9.65302 2.54936 11.0721 3.70674 12.2573C4.89541 13.4113 6.31867 13.9883 7.97654 13.9883C9.13392 13.9883 10.26 13.5984 11.3548 12.8187C12.247 12.2009 12.9134 11.4853 13.354 10.6718C13.5618 10.2881 13.9433 10.0117 14.3796 10.0117C15.0595 10.0117 15.5609 10.655 15.2895 11.2785C14.7732 12.4649 13.9778 13.4773 12.9032 14.3158C11.4643 15.4386 9.82209 16 7.97654 16C5.7869 16 3.91007 15.2203 2.34604 13.6608C0.782014 12.1014 0 10.2144 0 8C0 5.78557 0.782014 3.89864 2.34604 2.33918C3.91007 0.779727 5.7869 0 7.97654 0C8.91496 0 9.93157 0.233918 11.0264 0.701754C12.1525 1.1384 13.0283 1.68421 13.654 2.33918Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_600_4421">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                },
                {
                  label: 'Re-send to everyone',
                  labelOnClick: 'Sent to everyone',
                  disabled: meeting_participants_emails?.length == 0,
                  onClick: () => {
                    resendKeyInsightsEmail({ ...meetingData, ...backendMeetingData }, { sendToEveryone: true })
                    setTimeout(() => {
                      loadBackendMeetingData(false)
                    }, 4000)
                  },
                  icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="email">
                      <path id="icon" d="M18.0282 6.27193V4.38596L10 9.07895L1.97183 4.38596V6.27193L10 10.9211L18.0282 6.27193ZM18.0282 2.5C18.5603 2.5 19.0141 2.69006 19.3897 3.07018C19.7966 3.45029 20 3.88889 20 4.38596V15.614C20 16.1111 19.7966 16.5497 19.3897 16.9298C19.0141 17.3099 18.5603 17.5 18.0282 17.5H1.97183C1.43975 17.5 0.970266 17.3099 0.56338 16.9298C0.187793 16.5497 0 16.1111 0 15.614V4.38596C0 3.88889 0.187793 3.45029 0.56338 3.07018C0.970266 2.69006 1.43975 2.5 1.97183 2.5H18.0282Z" fill="white" />
                    </g>
                  </svg>
                },
                {
                  label: 'Email settings',
                  onClick: () => navigate('/settings/ai-summary-email'),
                  icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.73244 2C9.38663 1.4022 8.74028 1 8 1C7.25972 1 6.61337 1.4022 6.26756 2H1C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4H6.26756C6.61337 4.5978 7.25972 5 8 5C8.74028 5 9.38663 4.5978 9.73244 4H15C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2H9.73244ZM1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9H2.26756C2.61337 9.5978 3.25972 10 4 10C4.74028 10 5.38663 9.5978 5.73244 9H15C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H5.73244C5.38663 6.4022 4.74028 6 4 6C3.25972 6 2.61337 6.4022 2.26756 7H1ZM0 13C0 12.4477 0.447715 12 1 12H11.2676C11.6134 11.4022 12.2597 11 13 11C13.7403 11 14.3866 11.4022 14.7324 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H14.7324C14.3866 14.5978 13.7403 15 13 15C12.2597 15 11.6134 14.5978 11.2676 14H1C0.447715 14 0 13.5523 0 13Z" fill="white" />
                  </svg>
                }
              ]}
            />
          </div>
          <div>
            {greenSuccessCheckBoxOrGrayCross(email_summary_sent_to_myself, "AI summary sent to myself", "AI summary not sent to myself")}
            {greenSuccessCheckBoxOrGrayCross(email_summary_sent_to_everyone, "AI summary sent to everyone", "AI summary not sent to everyone")}
          </div>
        </div>

        <hr style={{ background: '#434343', marginTop: 24, marginBottom: 24 }} />

        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={SlackIcon} width="18" />

              <h5 style={{ marginTop: 0, marginLeft: 10, marginBottom: 0 }}>Slack
                {userIsPaid ? '' : PRO_BADGE}
              </h5>
            </div>
            <HoverDropdownMenu
              menuItems={slackIsConnected ? [
                {
                  label: 'Re-send to Slack',
                  labelOnClick: 'Sent to Slack',
                  hidden: !userIsPaid,
                  onClick: () => {
                    resendKeyInsightsSlack({ ...meetingData, ...backendMeetingData })
                    setTimeout(() => {
                      loadBackendMeetingData(false)
                    }, 2000)
                  },
                  icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_600_4421)">
                      <path d="M13.654 2.33918L15.147 0.850541C15.4622 0.536269 16 0.759512 16 1.20461V5.83831C16 6.45583 15.4458 6.92577 14.8366 6.82487L10.9241 6.17691C10.5222 6.11034 10.3643 5.61679 10.653 5.32932L12.1994 3.78947C11.0108 2.60429 9.60313 2.0117 7.97654 2.0117C6.31867 2.0117 4.89541 2.60429 3.70674 3.78947C2.54936 4.94347 1.97067 6.34698 1.97067 8C1.97067 9.65302 2.54936 11.0721 3.70674 12.2573C4.89541 13.4113 6.31867 13.9883 7.97654 13.9883C9.13392 13.9883 10.26 13.5984 11.3548 12.8187C12.247 12.2009 12.9134 11.4853 13.354 10.6718C13.5618 10.2881 13.9433 10.0117 14.3796 10.0117C15.0595 10.0117 15.5609 10.655 15.2895 11.2785C14.7732 12.4649 13.9778 13.4773 12.9032 14.3158C11.4643 15.4386 9.82209 16 7.97654 16C5.7869 16 3.91007 15.2203 2.34604 13.6608C0.782014 12.1014 0 10.2144 0 8C0 5.78557 0.782014 3.89864 2.34604 2.33918C3.91007 0.779727 5.7869 0 7.97654 0C8.91496 0 9.93157 0.233918 11.0264 0.701754C12.1525 1.1384 13.0283 1.68421 13.654 2.33918Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_600_4421">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                },
                {
                  label: 'Manage Slack settings',
                  onClick: () => {
                    navigate('/settings/integrations/slack')
                  },
                  icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1276_2192)">
                      <path fillRule="evenodd" clipRule="evenodd" d="M3.70526 11.6645L1.81592 12.7553C1.32512 13.0387 0.697539 12.8705 0.414177 12.3797C0.130815 11.8889 0.298975 11.2613 0.789772 10.978L2.67912 9.88716C2.18856 8.12618 2.92626 6.18982 4.58259 5.23353L8.52605 2.95677C8.80213 2.79738 9.15514 2.89197 9.31453 3.16805L9.53897 3.55679L12.2049 2.01762C12.6957 1.73426 13.3233 1.90242 13.6066 2.39322C13.89 2.88401 13.7218 3.51159 13.231 3.79496L10.5651 5.33412L11.5912 7.11139L14.257 5.5723C14.7478 5.28893 15.3754 5.45709 15.6587 5.94789C15.9421 6.43869 15.774 7.06627 15.2832 7.34963L12.6174 8.88873L12.8419 9.27764C13.0013 9.55371 12.9067 9.90673 12.6306 10.0661L8.68717 12.3429C7.03083 13.2992 4.98503 12.9698 3.70526 11.6645Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1276_2192">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }

              ] : [
                {
                  label: 'Connect Slack',
                  onClick: () => {
                    navigate('/settings/integrations')
                  },
                  icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1276_2192)">
                      <path fillRule="evenodd" clipRule="evenodd" d="M3.70526 11.6645L1.81592 12.7553C1.32512 13.0387 0.697539 12.8705 0.414177 12.3797C0.130815 11.8889 0.298975 11.2613 0.789772 10.978L2.67912 9.88716C2.18856 8.12618 2.92626 6.18982 4.58259 5.23353L8.52605 2.95677C8.80213 2.79738 9.15514 2.89197 9.31453 3.16805L9.53897 3.55679L12.2049 2.01762C12.6957 1.73426 13.3233 1.90242 13.6066 2.39322C13.89 2.88401 13.7218 3.51159 13.231 3.79496L10.5651 5.33412L11.5912 7.11139L14.257 5.5723C14.7478 5.28893 15.3754 5.45709 15.6587 5.94789C15.9421 6.43869 15.774 7.06627 15.2832 7.34963L12.6174 8.88873L12.8419 9.27764C13.0013 9.55371 12.9067 9.90673 12.6306 10.0661L8.68717 12.3429C7.03083 13.2992 4.98503 12.9698 3.70526 11.6645Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1276_2192">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              ]
              }
            />
          </div>
          <div>
            {greenSuccessCheckBoxOrGrayCross(!!slack_summary_sent_to_team_id, <>AI summary sent to <a href={getSlackDeepLink(slack_summary_sent_to_team_id, slack_summary_sent_to_channel_id)} target="_blank" style={{ "color": "var(--text-text-secondary, #C6C6C6)", "fontFeatureSettings": "'clig' off, 'liga' off", "fontFamily": "Roboto", "fontSize": "14px", "fontStyle": "normal", "fontWeight": "400", "lineHeight": "20px", "letterSpacing": "0.15px", textDecoration: 'underline' }} rel="noreferrer">Slack channel</a></>, "AI summary not sent to Slack")}
          </div>
        </div>

        {/*<hr style={{ background: '#434343', marginTop: 24, marginBottom: 24 }}/>

        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <div style={{ display: 'flex', alignItems: 'center'}}>
                <img src={HubspotIcon} width="18"/>

                <h5 style={{ marginTop: 0, marginLeft: 10, marginBottom: 0 }}>Hubspot
                  {userIsPaid ? '' : PRO_BADGE}
                </h5>
              </div>
              <HoverDropdownMenu
                menuItems={[
                  {
                    label: is_hubspot_connected ? 'Manage Hubspot settings' : 'Connect Hubspot',
                    onClick: () => {
                      navigate('/settings/integrations/hubspot')
                    },
                    icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1276_2192)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70526 11.6645L1.81592 12.7553C1.32512 13.0387 0.697539 12.8705 0.414177 12.3797C0.130815 11.8889 0.298975 11.2613 0.789772 10.978L2.67912 9.88716C2.18856 8.12618 2.92626 6.18982 4.58259 5.23353L8.52605 2.95677C8.80213 2.79738 9.15514 2.89197 9.31453 3.16805L9.53897 3.55679L12.2049 2.01762C12.6957 1.73426 13.3233 1.90242 13.6066 2.39322C13.89 2.88401 13.7218 3.51159 13.231 3.79496L10.5651 5.33412L11.5912 7.11139L14.257 5.5723C14.7478 5.28893 15.3754 5.45709 15.6587 5.94789C15.9421 6.43869 15.774 7.06627 15.2832 7.34963L12.6174 8.88873L12.8419 9.27764C13.0013 9.55371 12.9067 9.90673 12.6306 10.0661L8.68717 12.3429C7.03083 13.2992 4.98503 12.9698 3.70526 11.6645Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1276_2192">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                  }
                ]
              }
              />
          </div>
          <div>
            {greenSuccessCheckBoxOrGrayCross(isSavedToHubspot, <>AI summary and Transcript saved in <a href={getHubspotLink(hubspot_portal_id, hubspot_contact_ids_where_summary_is_saved?.[0], hubspot_meeting_id)} target="_blank" style={{ "color": "var(--text-text-secondary, #C6C6C6)","fontFeatureSettings":"'clig' off, 'liga' off","fontFamily":"Roboto","fontSize":"14px","fontStyle":"normal","fontWeight":"400","lineHeight":"20px","letterSpacing":"0.15px", textDecoration: 'underline'}}>your Hubspot account</a></>, "AI summary and transcript not saved")}
          </div>
          {could_not_detect_hubspot_contact ? <div>
            <div style={{marginTop: 15, "color":"var(--text-text-secondary, #C6C6C6)","fontFeatureSettings":"'clig' off, 'liga' off","fontFamily":"Roboto","fontSize":"14px","fontStyle":"normal","fontWeight":"400","lineHeight":"20px","letterSpacing":"0.15px"}}>
              Briefly couldn’t detect customers for this call. Make sure the participants on the call match contacts in Salesforce.
            </div>
            <SearchableDropdown onChange={newDropdownValue => {

              selectHubspotContact(newDropdownValue.value, meetingData.transcriptId, () => {
                loadBackendMeetingData()
              })
            }}/>
            <hr style={{ background: '#434343', marginTop: 24, marginBottom: 10 }}/>
            <button style={{ height: 32 }}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{left:0, right: 0, marginRight: 0, display: 'inline-block'}}>
                <path d="M12 6C12 6.46703 11.6214 6.84564 11.1544 6.84564H6.84564V11.1544C6.84564 11.6214 6.46703 12 6 12C5.53297 12 5.15436 11.6214 5.15436 11.1544V6.84564H0.845639C0.378606 6.84564 0 6.46703 0 6C0 5.53297 0.378605 5.15436 0.845638 5.15436H5.15436V0.845639C5.15436 0.378606 5.53297 0 6 0C6.46703 0 6.84564 0.378605 6.84564 0.845638V5.15436H11.1544C11.6214 5.15436 12 5.53297 12 6Z" fill="white"/>
              </svg>
              <span style={{ fontSize: 14, dislay: 'inline-block', marginLeft: 5 }}>
                Create new contact
              </span>
            </button>
          </div> : ''}
        </div>*/}
      </> : <>

      </>}

      {!userIsPaid ? <>
        <hr style={{ background: '#434343', marginTop: 24, marginBottom: 24 }} />

        <button style={{ fontSize: 14, height: 32, margin: 0 }} onClick={openCheckoutSessionInNewTab}>
          Upgrade to PRO now
        </button>
      </> : ''}

    </div>
  </div>


  var body;
  if (!meetingSummary || isGenerating) {
    body = <div className="generate-ai-summary" style={{ display: 'flex', justifyContent: 'center', marginTop: 60, flex: 1 }}>

      <div style={{ width: 400, textAlign: 'center' }}>
        <svg width="146" height="98" viewBox="0 0 146 98" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M24.7437 10.4934H120.594C122.954 10.4934 124.868 12.4067 124.868 14.7669V93.2983C124.868 95.6585 122.954 97.5718 120.594 97.5718H24.7437C22.3835 97.5718 20.4702 95.6585 20.4702 93.2983V14.7669C20.4702 12.4067 22.3835 10.4934 24.7437 10.4934Z" fill="#141414" />
          <path fillRule="evenodd" clipRule="evenodd" d="M30.9502 19.293H124.81V97.1184H30.9502V19.293Z" fill="#2C2C2C" />
          <path fillRule="evenodd" clipRule="evenodd" d="M121.078 10.4556H24.2618C22.2643 10.4556 20.6469 12.1192 20.6469 14.1681V19.2756H124.693V14.1717C124.693 12.1192 123.074 10.4556 121.078 10.4556Z" fill="#E44867" />
          <path fillRule="evenodd" clipRule="evenodd" d="M24.7437 10.4934H120.594C122.954 10.4934 124.868 12.4067 124.868 14.7669V93.2983C124.868 95.6585 122.954 97.5718 120.594 97.5718H24.7437C22.3835 97.5718 20.4702 95.6585 20.4702 93.2983V14.7669C20.4702 12.4067 22.3835 10.4934 24.7437 10.4934Z" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 24.0984H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 30.0818H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 36.0669H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 42.052H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 48.0369H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M24.2156 54.022H27.157" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M25.1071 14.6565H44.3315" stroke="white" strokeWidth="0.630001" strokeLinecap="round" strokeLinejoin="round" />
          <path fillRule="evenodd" clipRule="evenodd" d="M135.431 28.6717C139.65 30.9579 140.306 33.9816 140.39 35.2013L140.396 35.2915C140.396 35.306 140.397 35.3201 140.398 35.3339L140.4 35.413L140.401 35.4843L140.401 35.5476L140.4 35.6269L140.397 35.6868L140.392 35.7459C140.454 40.5574 139.482 41.7621 138.944 42.061L138.903 42.0822C138.89 42.0887 138.877 42.0947 138.864 42.1001L138.828 42.1151C138.816 42.1196 138.804 42.1236 138.793 42.1272L138.761 42.1369L138.731 42.1444L138.704 42.1499L138.68 42.1538L138.658 42.1563L138.632 42.158L138.612 42.1582L138.598 42.1574C136.442 41.9149 135.541 39.7564 135.171 38.2337L135.138 38.0928L135.108 37.9562L135.081 37.8243C135.072 37.7811 135.064 37.7388 135.056 37.6974L135.034 37.5762C135.031 37.5565 135.028 37.537 135.024 37.5178L135.006 37.4058L134.99 37.3006L134.976 37.2027L134.959 37.0703L134.946 36.9568L134.933 36.8376L134.924 36.7218L135.431 28.6717ZM125.143 28.0731C126.687 30.6672 127.093 33.5123 127.178 35.3L127.186 35.4697L127.191 35.6325L127.195 35.7881L127.197 35.9364C127.197 35.9605 127.198 35.9842 127.198 36.0077L127.198 36.1444L127.197 36.273L127.194 36.4503L127.19 36.608L127.184 36.7451L127.176 36.8947L127.167 37.0249L127.161 37.0941C127.235 41.4046 125.488 42.007 124.681 42.0561L124.62 42.0588C124.61 42.0591 124.6 42.0593 124.591 42.0595L124.536 42.0595L124.486 42.0581L124.441 42.0556L124.4 42.0524L124.35 42.0469L124.304 42.0401L124.282 42.036C123.127 41.8416 122.596 40.4142 122.353 39.0886L122.327 38.9362L122.302 38.7852C122.299 38.7601 122.295 38.7352 122.291 38.7103L122.27 38.5621L122.251 38.4165C122.248 38.3924 122.246 38.3685 122.243 38.3447L122.227 38.2037C122.225 38.1804 122.222 38.1574 122.22 38.1345L122.207 37.999L122.196 37.8679L122.186 37.7416L122.178 37.6205L122.168 37.4497L122.16 37.2932L122.155 37.1526L122.152 37.0294L122.15 36.8948L122.15 36.7284C122.206 31.6926 123.818 29.3701 124.653 28.5029L124.719 28.4357C124.74 28.4144 124.761 28.3941 124.781 28.3748L124.839 28.3199L124.893 28.271L124.943 28.2279L125.008 28.1737L125.045 28.1444L125.102 28.1013L125.143 28.0731ZM114.472 28.7488L114.901 36.8251L114.896 36.8773L114.884 36.9943L114.872 37.0933L114.857 37.2119L114.837 37.3485L114.821 37.4488C114.818 37.4661 114.815 37.4837 114.812 37.5015L114.792 37.6118C114.789 37.6308 114.785 37.6499 114.782 37.6693L114.759 37.7886L114.733 37.9133C114.724 37.9557 114.714 37.9989 114.704 38.0428L114.673 38.1768C114.31 39.6733 113.399 41.8864 111.171 41.959L111.152 41.9583L111.12 41.9547L111.099 41.951C111.095 41.9503 111.092 41.9495 111.088 41.9486L111.062 41.9424C111.057 41.9412 111.053 41.9399 111.048 41.9385L111.018 41.9291L110.985 41.9172C110.979 41.9149 110.973 41.9126 110.968 41.9101L110.931 41.8939C110.925 41.8909 110.918 41.8878 110.912 41.8845L110.872 41.8632C110.354 41.571 109.351 40.3882 109.433 35.6068L109.437 35.415L109.433 35.3569L109.431 35.2969L109.43 35.2461L109.43 35.187L109.431 35.1198L109.434 35.0449L109.438 34.9625L109.444 34.8728C109.448 34.8263 109.453 34.7771 109.458 34.7255L109.471 34.6191C109.643 33.286 110.498 30.5712 114.472 28.7488Z" fill="#F97238" />
          <path fillRule="evenodd" clipRule="evenodd" d="M124.346 0.775453C124.346 0.775453 111.52 7.08199 115.015 37.4173L134.581 37.5043C134.581 37.5043 138.377 10.8397 127.354 0.868944C127.354 0.868944 126.111 -0.216863 124.346 0.775453Z" fill="#434343" stroke="#C6C6C6" strokeWidth="0.376143" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M124.469 0.638901L124.469 0.639144L124.478 0.634033C125.329 0.137863 126.04 0.165844 126.534 0.30953C126.784 0.38212 126.981 0.485278 127.115 0.570145C127.182 0.612523 127.233 0.649987 127.266 0.676161C127.278 0.685817 127.288 0.693758 127.294 0.699658L127.311 0.715654C130.91 4.11244 132.948 9.36175 134.053 14.936L115.967 14.9779C117.358 9.295 119.476 5.71547 121.248 3.55518C122.146 2.46004 122.956 1.72852 123.54 1.27206C123.831 1.04381 124.066 0.884283 124.227 0.782439C124.307 0.731517 124.369 0.695014 124.41 0.67155C124.431 0.659818 124.446 0.651347 124.456 0.645963L124.467 0.640181L124.469 0.638986L124.469 0.638901Z" fill="#E44867" stroke="#C6C6C6" strokeWidth="0.375962" />
          <ellipse cx="124.762" cy="20.9417" rx="2.92938" ry="3.03435" transform="rotate(-45.5 124.762 20.9417)" fill="#C6C6C6" />
          <path d="M128.12 3.70459C128.12 3.70459 129.234 4.91833 130.123 7.09322" stroke="white" strokeWidth="0.564215" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M59.4377 61.4982H90.5507" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M42.05 68.3974H107.939" stroke="#C6C6C6" strokeWidth="0.42" strokeLinecap="round" strokeLinejoin="round" />
          <path fillRule="evenodd" clipRule="evenodd" d="M57.6168 75.2068H92.3716C93.9176 75.2068 95.1709 76.4601 95.1709 78.0061V84.8927C95.1709 86.4388 93.9176 87.692 92.3716 87.692H57.6168C56.0708 87.692 54.8175 86.4388 54.8175 84.8927V78.0061C54.8175 76.4601 56.0708 75.2068 57.6168 75.2068Z" fill="#E44867" />
          <path d="M67.6276 81.5963H82.3849" stroke="white" strokeWidth="0.630001" strokeLinecap="round" strokeLinejoin="round" />
          <path fillRule="evenodd" clipRule="evenodd" d="M5.38959 26.4658L1.11426 50.5284H45.6121L48.9515 26.4658H5.38959V26.4658Z" fill="#2C2C2C" />
          <path fillRule="evenodd" clipRule="evenodd" d="M5.38959 26.4658L1.11426 50.5284H45.6121L48.9515 26.4658H5.38959V26.4658Z" stroke="#C6C6C6" strokeWidth="0.31871" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="15.7788" cy="38.6161" r="1.49526" fill="#EC8E00" />
          <circle cx="24.5897" cy="38.6161" r="1.49526" fill="#EC8E00" />
          <circle cx="33.362" cy="38.6161" r="1.49526" fill="#EC8E00" />
        </svg>

        <h5>{isGenerating ? 'Generating AI summary...' : 'Your AI Summary is ready to be generated!'} </h5>

        {!isGenerating && <button style={{ height: 40, width: 260 }} onClick={() => handleGenerateSummary()}>{meetingSummaryWasRequestedBefore ? 'View' : 'Generate'} AI summary {aiSummaryCostsAiCredit ? '[1 AI Credit]' : ''}</button>}

        {isGenerating && <div className="loader-container">
          <div className="loader-inner" />
        </div>}
      </div>

    </div>
  } else {
    const anyError = meetingSummary && SUMMARY_COLUMNS_CONFIG.find(items => items.find(x => meetingSummary?.[x.key]?.error))

    body = (
      <div id="summary-outer-container">
        <div id="summary-container" className={anyError && 'is-error'}>
          {meetingSummary ? <div>
            {anyError ? <div className="summary-error">
              There was an issue with OpenAI while generating some AI summaries, try again later
              <br />
              <a onClick={() => handleGenerateSummary()}>Try again</a>
            </div> : ''}

            <ButtonWithTimeoutReplaceOnClick

              initialText={
                <>
                  <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2512 13.2191V4.31277H4.28103V13.2191H11.2512ZM11.2512 3.0617C11.5888 3.0617 11.8867 3.19078 12.1449 3.44894C12.403 3.68723 12.5321 3.97518 12.5321 4.31277V13.2191C12.5321 13.5567 12.403 13.8546 12.1449 14.1128C11.8867 14.3709 11.5888 14.5 11.2512 14.5H4.28103C3.94344 14.5 3.64557 14.3709 3.38741 14.1128C3.12925 13.8546 3.00018 13.5567 3.00018 13.2191V4.31277C3.00018 3.97518 3.12925 3.68723 3.38741 3.44894C3.64557 3.19078 3.94344 3.0617 4.28103 3.0617H11.2512ZM9.34486 0.5V1.78085H1.71933V10.6872H0.468262V1.78085C0.468262 1.44326 0.587411 1.14539 0.825709 0.887234C1.08386 0.629078 1.38174 0.5 1.71933 0.5H9.34486Z" fill="white" />
                  </svg>
                  Copy entire AI summary
                </>
              }

              clickedText={
                <>
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="white" d="M6.38498 12.0188L13.5962 4.80751L12.4695 3.64319L6.38498 9.7277L3.53052 6.87324L2.40376 8L6.38498 12.0188ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z" />
                  </svg>
                  Copied to clipboard
                </>
              }

              onClick={() => {
                var concat = ''
                SUMMARY_COLUMNS_CONFIG.map(items => items.map(({ label, key }) => {
                  concat += label + ':\n'
                  concat += meetingSummary[key] + '\n\n'
                }))
                copyToClipboard(concat)
              }}

            />
            <div className="summary-columns">
              {SUMMARY_COLUMNS_CONFIG.map(items => <div className="summary-column">
                {items.map(({ label, key }) => {
                  return <SummarySection
                    custom_bullet_summary_label={custom_bullet_summary_label}
                    header={label} text={meetingSummary[key]}
                    setShowZoomTranscriptInfoPopup={setShowZoomTranscriptInfoPopup}
                    setShowMsTeamsTranscriptInfoPopup={setShowMsTeamsTranscriptInfoPopup}
                    isBackend={isBackend}
                    getSpeakerColourByName={isBackend ? null : speakerName => {
                      var speakerId = null
                      for (var id in meetingData.deviceNamesById) {
                        if (meetingData.deviceNamesById[id] === speakerName) {
                          speakerId = id;
                          break;
                        }
                      }

                      if (speakerId) {
                        return meetingData.deviceColorsById[speakerId]
                      } else {
                        return 'white'
                      }
                    }}
                    searchWords={searchWords}
                  />

                })}
              </div>)}
            </div>
          </div> : ''}
        </div>
      </div>
    );
  }

  return <div style={{ display: 'flex', height: '100%', position: 'relative' }}>
    {leftSidebar}
    {body}
  </div>


}
